<template>
  <div class="coq-modal">

    <h3>Migration du site</h3>
    <p>Les 22, 23 et 24 novembre prochains, certains services du site seront temporairement indisponibles en raison de la migration vers une nouvelle plateforme. Cela inclut :
    </p>
    <ul>
      <li>L'inscription des nouveaux membres et le renouvellement des membres existants</li>
      <li>La modification des informations de votre compte</li>
    </ul>

    <p>Merci de votre compréhension et de votre patience pendant cette période de transition.</p>

    <div class="coq-modal__footer">
      
      <a class="btn btn-primary" @click="$emit('close')">
        J'ai compris
      </a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'warningModal',
  };
</script>

<style scoped></style>
